import {
  MdFavoriteBorder,
  MdFlashOn,
  MdStarBorder,
  MdVisibility,
  MdWhatshot,
} from "react-icons/md";
import "./Hotlinks.scss";
import { getPosts } from "../../redux/features/post/postSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Link } from "react-router-dom";

export const Hotlinks = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const { posts } = useSelector((state) => state.post);
  const latestUpdate = posts.find((post) => post?.category === "World News");

  let date = new Date(latestUpdate?.createdAt);

  const d = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="hotLinks">
      <div className="hotlinksWrapper">
        <div className="item">
          <Link>
            <MdStarBorder className="icon" />
            <span>Featured News</span>
          </Link>
        </div>
        <div className="item">
          <Link>
            <MdFavoriteBorder className="icon" />
            <span>Most Popular</span>
          </Link>
        </div>
        <div className="item">
          <Link>
            <MdWhatshot className="icon" />
            <span>Hot News</span>
          </Link>
        </div>
        <div className="item">
          <Link>
            <MdFlashOn className="icon" />
            <span>Trending News</span>
          </Link>
        </div>
        <div className="item">
          <Link>
            <MdVisibility className="icon" />
            <span>Most watched</span>
          </Link>
        </div>
      </div>

      <div className="news--ticker">
        <div className="container">
          <div className="title">
            <h2>News Update</h2>
            <span>(Update {d})</span>
          </div>
        </div>
      </div>
    </div>
  );
};
